import { render, staticRenderFns } from "./shopping-duihuan.vue?vue&type=template&id=a7b7f48c&scoped=true"
import script from "./shopping-duihuan.vue?vue&type=script&lang=js"
export * from "./shopping-duihuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b7f48c",
  null
  
)

export default component.exports